export const sendCommand = (websocket, cmd, arg = "") => {
    if (websocket.readyState === websocket.OPEN) {
        let jsonMessage = JSON.stringify({ command: cmd, arg: arg });
        websocket.send(jsonMessage);
    }
};